import { Loader, UnsubscriberClass } from '@aston/foundation/classes';
import { LoaderSpinnerComponent } from '@aston/foundation/components';
import { IFilterOperator } from '@aston/foundation/enums';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take, withLatestFrom } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';

import { SuperDebtorsRequestsListFilterSpecService } from '../../../requests-module/services/requests-filter-spec.service';
import { RequestsListPageStore } from '../../../requests-module/pages/requests-list-page/store/requests-list-page.store';
import * as AppStoreSelectors from '../../../root-store/app-store/selectors';
import * as RoutesDefinitions from '../../../routes-definitions';
import { AuthenticationService } from '../../services';
import { IAuthParams } from '../../models';

@Component({
	selector: 'login-page',
	templateUrl: './login-page.component.html',
	imports: [FormsModule, LoaderSpinnerComponent]
})
export class LoginPageComponent extends UnsubscriberClass implements OnInit {
	protected prSpecs = inject(SuperDebtorsRequestsListFilterSpecService);
	protected authenticationService = inject(AuthenticationService);
	protected prStore = inject(RequestsListPageStore);
	protected activatedRoute = inject(ActivatedRoute);
	protected store = inject(Store);
	protected router = inject(Router);


	formLoader = new Loader();

	ngOnInit() {
		const authParams = this.activatedRoute.snapshot.params;
		const query = this.activatedRoute.snapshot.queryParams;

		console.info('Starting auth check with params', authParams);  

		this.authenticationService.login(authParams as IAuthParams).pipe(
			withLatestFrom(this.store.select(AppStoreSelectors.selectTenant)),
			take(1))
			.subscribe(([auth, tenant]) => {
				if (!auth) return this.redirect();

				if (query['dunningActionId']) {
					return this.router.navigateByUrl(RoutesDefinitions.getDunningAccountingFullPath(+query['dunningActionId']))
				}
				else if (query['invoicingTab'] && tenant.isManualInvoiceEnabled) {
					return this.router.navigateByUrl(RoutesDefinitions.getDunningInvoicingFullPath())
				}
				else if (query['requestTab'] && query['portalRequestId']) {
					this.prStore.toggleInactiveRequests(true)
					this.prStore.debtorsRequestsAddFilters([ this.prSpecs.byId(IFilterOperator.Equals, +query['portalRequestId']) ])
					return this.router.navigateByUrl(RoutesDefinitions.getRequestsListFullPath())
				}

				// User Story 32084: 💰[ACC][Facturation][Options] Impact de la désactivation de l'option "Module facturation"
				// Add correct redirection in this case

				// default redirect to home
				this.router.navigateByUrl(RoutesDefinitions.getAccountingListFullPath())
			});
	}

	redirect() {
		this.router.navigateByUrl(RoutesDefinitions.getAuthenticationIssueFullPath())
	}
}
